module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"add":"Добавить карту","renewSubscriptionAfterCreating":"Оплатить продление подписки после добавления способа оплаты"}}')
  delete Component.options._Ctor
}
